// Theme Scripts
(function($){

    $(document).ready(function() {
        $('.open-close-wrapper').click(function(){
            $('.open', this).toggleClass('active');
            $('.close', this).toggleClass('active');
            $(this).next('.form-wrapper').slideToggle();
        });
        $('.apply-button a').click(function(e){
            e.preventDefault();
            $(this).parent().parent().parent().find('.form-wrapper').slideToggle();
        });
        $('.menu-button.login-button, a[href="/wp-login.php"], a[href*="/kirjaudu/"]').click(function(e){
            console.log('hit');
            e.preventDefault();
            initLoginPopup();
        });
        $('.group-service, .item.campaign .content-wrapper').matchHeight({
            property: 'min-height',
        });

        checkCookie();

        $('#front-popup .mfp-close').click(function( e ){
			var expiry = 1;
			setCookie('cuc',1,expiry);
		});

        var windowURL = window.location.href;
        console.log(windowURL);
        if (windowURL.indexOf('shared') > -1) {
            $('header').css('display', 'none');
            $('footer').css('display', 'none');
        }

        if( $('.kampanjat-otsikkorivi').length > 0 ){
            $('.kampanjat-otsikkorivi').each(function(){
                var parent = $(this).parent();
                $(this).clone().addClass('mobile-only').appendTo( parent );
            });    
        }
       
    });

    $(window).bind('scroll', function () {
        if ($(window).scrollTop() > 500) {
            $('#main-header').addClass('nav-down');
        }
        else
        {
            $('#main-header').removeClass('nav-down');
        }
    });
    
    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('#main-header').outerHeight();
    
    $(window).scroll(function(event){
        didScroll = true;
    });
    
    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 500);
    
    function hasScrolled() {
        var st = $(this).scrollTop();
    
        // Make sure they scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta)
            return;
    
        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
            $('#main-header').removeClass('nav-down').addClass('nav-up');
        } else {
            // Scroll Up
            if(st + $(window).height() < $(document).height()) {
                $('#main-header').removeClass('nav-up');
            }
        }
    
        lastScrollTop = st;
    }

    function initPopup(){
        if (jQuery('#front-popup').length ) {
           jQuery.magnificPopup.open({
             items: {
                 src: '#front-popup' 
             },
             type: 'inline'
           });
        }
     }

    function initLoginPopup(){
        if (jQuery('#login-popup').length ) {
           jQuery.magnificPopup.open({
             items: {
                 src: '#login-popup' 
             },
             type: 'inline'
           });
        }
     }

     function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }
  
      function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
  
      function checkCookie() {
        var cuc = getCookie("cuc");
        
        if (cuc != "") {
            //nothing
        } 
        else {
            initPopup();
        }
      }

})(jQuery)